export default __webpack_public_path__ + "static/media/FlyingFrog25.4aaa4057.png";